import { render } from "./disciplina.vue?vue&type=template&id=59f5a094"
import script from "./disciplina.vue?vue&type=script&lang=js"
export * from "./disciplina.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__